import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { type ActionsObservable } from 'redux-observable';
import { type MiddlewareAPI } from 'redux';
import { of } from 'rxjs/observable/of';

import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';
import {
	FETCH_CONFLUENCE_SPACES,
	fetchConfluenceSpacesError,
	updateConfluenceSpaces,
} from '../actions';

import { requestConfluenceSpaces$ } from './requests';
import { getProjectId, getProjectType } from '../project/selectors';
import { type State } from '../types';

const decodeHtml = (html: any) => {
	const txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;
};

export default (action$: ActionsObservable<any>, store?: MiddlewareAPI<State>) =>
	action$.ofType(FETCH_CONFLUENCE_SPACES).switchMap(() =>
		requestConfluenceSpaces$(getProjectId(store!.getState()), getProjectType(store!.getState()))
			.map((value) => {
				fetchSuccess('confluence.spaces');
				return updateConfluenceSpaces(
					value.map((space) => ({
						spaceKey: space.id,
						spaceName: decodeHtml(space.text),
					})),
				);
			})
			.catch((err) => {
				fetchFailed('confluence.spaces', err);
				return of(fetchConfluenceSpacesError());
			}),
	);
